import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';

interface StatusBadgeProps {
  statusStyle: { bg: string; text: string; label: string };
  tooltipLines: string[];
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ statusStyle, tooltipLines }) => {
  const badgeRef = useRef<HTMLSpanElement>(null);
  const [pos, setPos] = useState<{ top: number; right: number } | null>(null);

  const show = () => {
    const rect = badgeRef.current?.getBoundingClientRect();
    if (rect) setPos({ top: rect.top - 4, right: window.innerWidth - rect.right });
  };
  const hide = () => setPos(null);

  return (
    <span
      ref={badgeRef}
      onMouseEnter={show}
      onMouseLeave={hide}
      className={`inline-flex items-center justify-center w-[70px] h-5 rounded-sm typo-caption !font-bold cursor-default ${statusStyle.bg} ${statusStyle.text}`}
    >
      {statusStyle.label}
      {pos && createPortal(
        <div
          className="fixed px-2 py-1 bg-neutral-80 text-white typo-caption rounded whitespace-nowrap -translate-y-full pointer-events-none"
          style={{ top: pos.top, right: pos.right }}
        >
          {tooltipLines.map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </div>,
        document.body,
      )}
    </span>
  );
};

export default StatusBadge;
